/**
 * FinaDevices API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  deleteFinaDevice,
  getFinaDevice,
  listFinaDevices,
  registerFinaDevice,
} from "../generated/fina-devices/fina-devices";

import { wrapMethod } from "./utils";

export const finaDevices = {
  /** @see listFinaDevices */
  listFinaDevices: wrapMethod(listFinaDevices),

  /** @see registerFinaDevice */
  registerFinaDevice: wrapMethod(registerFinaDevice),

  /** @see getFinaDevice */
  getFinaDevice: wrapMethod(getFinaDevice),

  /** @see deleteFinaDevice */
  delete: wrapMethod(deleteFinaDevice),
} as const;

export type FinaDevicesApi = typeof finaDevices;
